<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5122 4.9135L6.84524 10.8585L4.05224 9.4585C3.98724 9.42584 3.91589 9.40775 3.84318 9.40551C3.77046 9.40326 3.69813 9.41691 3.63124 9.4455L1.02324 10.5675C0.948205 10.5998 0.882214 10.6499 0.831036 10.7136C0.779858 10.7772 0.745052 10.8524 0.729661 10.9326C0.71427 11.0128 0.718763 11.0956 0.742746 11.1737C0.766729 11.2518 0.809473 11.3228 0.86724 11.3805L4.61124 15.1255C4.68057 15.1947 4.76871 15.2421 4.86472 15.2616C4.96072 15.2812 5.06035 15.2721 5.15124 15.2355L12.3452 12.3585L9.79224 19.1665C9.75704 19.2605 9.75094 19.3629 9.77474 19.4604C9.79853 19.5579 9.85112 19.646 9.92567 19.7132C10.0002 19.7804 10.0933 19.8236 10.1927 19.8373C10.2921 19.8509 10.3934 19.8342 10.4832 19.7895L13.1992 18.4325C13.2957 18.3842 13.3739 18.3059 13.4222 18.2095L17.3482 10.3585L22.0482 8.6085C22.2959 8.51157 22.5217 8.36624 22.7125 8.18099C22.9033 7.99575 23.0552 7.77431 23.1594 7.52965C23.2635 7.28498 23.3179 7.022 23.3192 6.75608C23.3205 6.49016 23.2688 6.22664 23.1671 5.98095C23.0654 5.73525 22.9157 5.51232 22.7267 5.32518C22.5378 5.13804 22.3134 4.99045 22.0668 4.89105C21.8201 4.79166 21.5562 4.74245 21.2903 4.7463C21.0244 4.75016 20.7619 4.807 20.5182 4.9135H20.5122Z"
      stroke="#213E7A"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0165 6.86508L9.55051 4.19808C9.42819 4.14752 9.29082 4.14752 9.16851 4.19808L6.77951 5.18808C6.68811 5.2259 6.60998 5.28999 6.55501 5.37222C6.50004 5.45446 6.4707 5.55116 6.4707 5.65008C6.4707 5.74899 6.50004 5.84569 6.55501 5.92793C6.60998 6.01016 6.68811 6.07425 6.77951 6.11208L12.3995 8.43708"
      stroke="#213E7A"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "PlaneIcon",
};
</script>
